import React from 'react';
import Paper from '@material-ui/core/Paper';
import { t } from 'ttag';
import DataTable from '../../../components/DataTable';
import useApi from '../../../api';
import useDataList from '../../../hooks/useDataList';
import { BASE_STATUS_TITLES } from '../../../utils/enums';

const ListView = () => {
  const api = useApi();
  const { data, loading, onEdit, onAdd, onDelete } = useDataList({
    schema: api.schema.clubs,
    router: api.router.clubs,
  });
  const columns = [
    { title: t`Id`, field: 'id', editable: 'never' },
    { title: t`Назва`, field: 'shortName' },
    {
      title: t`Статус`,
      field: 'status',
      render: ({ status }) => BASE_STATUS_TITLES[status],
    },
  ];

  return (
    <Paper>
      <DataTable
        isLoading={loading}
        title={t`Список клубів`}
        columns={columns}
        data={data || []}
        onAdd={onAdd}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </Paper>
  );
};

export default ListView;
